import { useMemo } from "react";
import { automaticCountry, useCountry } from "./countryStore.js";

/**
 * Settings → Your country (owner, 2026-10-20): whose categories come first in the guide, Movies
 * and Series, and whose channels Home's Live Now features. Automatic follows the TV's region (a
 * white-label build's own country when it sets one).
 */

/** The countries providers tag their categories with most (library/countryTag.ts), and TVmaze's. */
const COUNTRIES = [
  "US", "GB", "CA", "AU", "IE", "NZ", "DE", "FR", "NL", "BE", "ES", "PT", "IT", "SE", "NO", "DK", "FI", "PL",
  "GR", "TR", "RU", "UA", "RO", "HU", "CZ", "AL", "IL", "SA", "IN", "PK", "BD", "PH", "CN", "JP", "KR", "TH",
  "VN", "BR", "MX", "AR", "JM", "NG", "ZA",
];

function countryName(code: string): string {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" }).of(code) ?? code;
  } catch {
    return code;
  }
}

export function CountryCard() {
  const chosen = useCountry((s) => s.chosen);
  const setChosen = useCountry((s) => s.setChosen);
  const automatic = automaticCountry();
  const options = useMemo(
    () => COUNTRIES.map((code) => ({ code, name: countryName(code) })).sort((a, b) => a.name.localeCompare(b.name)),
    [],
  );
  return (
    <div className="settings-card">
      <h2 className="settings-card-title">Your country</h2>
      <p className="settings-card-desc">
        Your country's channel groups come first in the guide, Movies and Series, and Live Now on Home shows its
        channels.
      </p>
      <div className="settings-row">
        <label className="settings-row-label" htmlFor="your-country">
          Country
        </label>
        <select
          id="your-country"
          className="library-select"
          value={chosen ?? ""}
          onChange={(e) => setChosen(e.target.value || null)}
          aria-label="Whose channel groups come first"
        >
          <option value="">Automatic ({countryName(automatic)})</option>
          {options.map(({ code, name }) => (
            <option key={code} value={code}>
              {name}
            </option>
          ))}
        </select>
      </div>
      <p className="settings-row-hint">Automatic follows the TV's region. Saved on this device.</p>
    </div>
  );
}
